
import { defineComponent, defineAsyncComponent } from 'vue';
import { Steps, message } from 'ant-design-vue';
import Modal from '@/components/Modal.vue';
import { CustomCaseClass } from './js/case';

const CustomCase = CustomCaseClass.getInstance(0);
const asyncBasicInfo = defineAsyncComponent(() => import('./basicinfo/basicInfo.vue'));
const asyncUnitExperiment = defineAsyncComponent(() => import('./unitExperiment/unitExperiment.vue'));
const asyncScenarioConstruction = defineAsyncComponent(() => import('./scenarioConstruction/index.vue'));
const asyncGradingSystem = defineAsyncComponent(() => import('./gradingSystem/gradingSystem.vue'));

export default defineComponent({
  components: {
    aSteps: Steps,
    aStep: Steps.Step,
    basicInfo: asyncBasicInfo,
    unitExperiment: asyncUnitExperiment,
    scenarioConstruction: asyncScenarioConstruction,
    gradingSystem: asyncGradingSystem,
    aModal: Modal,
  },
  data() {
    return {
      activeStep: 0,
      stepStyle: {
        boxShadow: '0px -1px 0 0 #e8e8e8 inset',
        height: '60px',
      },
      steps: [
        { title: '案例信息', status: 'process', disabled: false },
        { title: '单元实验', status: 'wait', disabled: false },
        { title: '情景构建', status: 'wait', disabled: false },
        { title: '评分系统', status: 'wait', disabled: false },
      ],
      modals: {
        back: false,
      },
    };
  },
  methods: {
    changeStep(step: number) {
      console.log(step, 'step', !CustomCase.checkUnitExperiment(), false);
      if (!this.$route.params.caseId) {
        message.error('请依次完成各模块内容！');
      } else if (step > 1 && !CustomCase.checkUnitExperiment()) {
        message.error('请依次完成各模块内容！');
      } else if (step > 2 && !CustomCase.checkScenario()) {
        message.error('请依次完成各模块内容！');
      } else {
        this.activeStep = step;
      }
      // this.activeStep = step;
    },
    handleNext() {
      if (this.activeStep < 3) {
        this.activeStep += 1;
      }
    },
    modalBackConfirm() {
      this.$router.push('/Teacher/customCase');
    },
  },
  setup() {
    return {};
  },
});
